// Stub implementation for useThemeAware hook

export function useThemeAware() {
  return {
    themeColors: {},
    platformContext: 'default',
    isDarkMode: false,
    platform: 'default',
    isDark: false,
    accentColor: '#FFC008'
  };
}